module.exports = __webpack_public_path__ + "static/yoga-0d17e97fddea86eaabbdaf83d98bde0d.jpg";